import React from 'react'

import TagIcon from "./TagIcon"

const TagNew = ({tag, tagCount}) => {

    return (
        <button className={'mr-2 flex dark:text-gray-300 text-black items-center rounded-full px-2 py-1 transition-colors duration-300 border dark:border-gray-600 border-gray-600 dark-hover:border-'+tag+' dark-hover:text-'+tag+' hover:border-'+tag+' hover:text-'+tag}>
            <TagIcon tag={tag}/>
            <span className="ml-1 font-thin text-xxs">{tag}</span>
            {tagCount &&<span className="text-xxs">&nbsp;{tagCount[tag]}</span>}
        </button>
    )
}

export default TagNew